import { Capacitor } from '@capacitor/core';
import { Clipboard } from '@capacitor/clipboard';
import copy from 'copy-to-clipboard';

/**
 * Copy `message`, resolving to whether it actually landed — so a caller can say "copied"
 * only when it did.
 *
 * On web this goes through `copy-to-clipboard`, which is `document.execCommand('copy')`
 * and nothing else: it never touches `navigator.clipboard`, and needs no secure context,
 * so it also works on plain http where the async Clipboard API is not exposed. When
 * execCommand fails it opens a `window.prompt` holding the text and returns false — so a
 * false here is not necessarily a failed copy (the user can still copy from the prompt),
 * and the failure path is not silent.
 *
 * On native it goes through the Capacitor Clipboard plugin, which rejects on failure.
 *
 * The return value is additive: the existing call sites ignore it and behave exactly as
 * before, including their unconditional success toasts.
 */
export const copyToClipboard = async message => {
  const currentPlatform = Capacitor.getPlatform();
  if (currentPlatform === 'web') {
    return copy(message);
  } else {
    await Clipboard.write({ string: message });
    return true;
  }
};
